import { ApolloError } from "@apollo/client";
import { Button } from "react-migration/components/DeprecatedButton";
import { Loading } from "react-migration/components/Loading";

import { PurchaseErrors, TransactionStatus } from "react-migration/domains/ownership/components/TransactionStatus";
import { PurchaseTitleDocumentResponse } from "../usePurchaseTitleDocuments/usePurchaseTitleDocuments";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type PurchaseStatusType = {
  onCancel: () => void;
  transaction?: PurchaseTitleDocumentResponse;
  requestError?: ApolloError;
  loading: boolean;
  setSelectedStep: (v: number) => void;
};

export const PurchaseStatus = ({
  onCancel,
  transaction,
  requestError,
  loading,
  setSelectedStep,
}: PurchaseStatusType) => {
  const { t } = useTranslation();
  const INVALID_CREDENTIALS_ERROR_MESSAGE: PurchaseErrors = "invalid_credentials";
  return (
    <div data-testid="step-3-purchased" className="flex flex-col mx-4 h-full">
      {loading ? (
        <div className="overflow-y-auto max-h-[400px] grow pt-20">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col overflow-y-auto h-[400px] justify-center">
          <TransactionStatus transaction={transaction} requestError={requestError} />
        </div>
      )}
      <div className="flex justify-end pt-4">
        {requestError?.message === INVALID_CREDENTIALS_ERROR_MESSAGE && (
          <Button.Secondary onClick={() => setSelectedStep(2)} data-testid="back-button" className="mr-2">
            {t("title_purchase.back")}
          </Button.Secondary>
        )}
        <Button.Primary onClick={onCancel}>{t("title_purchase.close")}</Button.Primary>
      </div>
    </div>
  );
};
